import React from 'react';
import EventList from '../components/EventList';
import { eventsAPI } from '../services/api';

const LatestColloquia = () => {
  return (
    <EventList 
      fetchEvents={eventsAPI.getLatestColloquia} 
      title="Latest Colloquia" 
    />
  );
};

export default LatestColloquia;